import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoacheeProfileMeetingsController } from 'presentation/page/profile/coachee-profile/coachee-profile-meetings/coachee-profile-meetings.controller';
import { CoacheeProfileMeetingsStore } from 'presentation/page/profile/coachee-profile/coachee-profile-meetings/coachee-profile-meetings.store';

@Component({
	selector: 'spr-coachee-profile-meetings',
	templateUrl: './coachee-profile-meetings.component.html',
	providers: [CoacheeProfileMeetingsStore, CoacheeProfileMeetingsController],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'block',
	},
})
export class CoacheeProfileMeetingsComponent {
	constructor(public controller: CoacheeProfileMeetingsController) {}

	public onReached() {
		this.controller.loadNextPage();
	}
}
